@import './../style.module';

@modal-header-height: 50px;

.modal-header {
  height: @modal-header-height;
  padding-left: @modal-padding;
  padding-right: @modal-padding;
}
